import { useTheme } from "./ThemeContext";

/**
 * ThemeIcons component
 * @param {boolean} isDropdown - if true, layout is horizontal (for dropdown), else default
 */
export default function ThemeIcons({ isDropdown = false }) {
  const { theme, setTheme, themes } = useTheme();

  return (
    <div
      className={`flex flex-wrap mt-[-37px] gap-3 ${
        isDropdown
          ? "flex-row justify-between p-2 w-full"
          : "flex-row space-x-2"
      }`}
    >
      {Object.entries(themes).map(([key, value]) => (
        <button
          key={key}
          onClick={() => setTheme(key)}
          aria-label={`Switch to ${value.label} theme`}
          className={`p-2 rounded transition-all duration-200 flex items-center justify-center text-xl
            ${
              theme === key
                ? "bg-diff text-black"
                : "hover:bg-diff hover:text-black bg-bg text-text"
            }`}
        >
          {value.icon}
        </button>
      ))}
    </div>
  );
}
